import ListJoiningReasons from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const JoiningReasonsRoutes = [
  {
    path: '/joining-reasons',
    name: 'ListJoiningReasons',
    component: ListJoiningReasons,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'joinning_reason:list'
    }
  },

  {
    path: '/joining-reason/',
    name: 'CreateJoiningReason',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'joining_reason:create'
    }
  },
  {
    path: '/joining-reason/:id',
    name: 'UpdateJoiningReason',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'joining_reason:update'
    }
  },
  {
    path: '/joining-reason/view/:id',
    name: 'GetJoiningReason',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'joining_reason:get'
    }
  }
]
